import styled from "styled-components";
export const OPBox = styled.div`
  max-height: 667px;
  max-width: 375px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  height: 100%;
  &&::-webkit-scrollbar {
    display: none;
  }
`;
export const Title = styled.div`
  line-height: 1.4;
  margin-bottom: 20px;
  font-size: 18px;

  h4 {
    text-transform: none;
  }
  p {
    font-family: "GT America, regular";
    width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  textarea {
    text-transform: none;

    font-family: "GT America, regular";
    background: transparent;
    border: none;
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 #ffb000;
    font-size: 18px;
    margin: auto;
    appearance: none;
    cursor: ${(p) => (p.copyCursor ? "auto" : "copy")};
    width: 100%;
    max-width: 500px;
    resize: none;
    user-select: text !important;
    line-height: 1.4;
    font-weight: 300;
    scrollbar-width: none;
    :focus {
      outline-offset: 10px;
      outline: none;
      border: none;
      outline: 0;
    }
    ::selection {
      background: none;
      border: none;
      text-decoration-line: underline;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }
  }
`;
export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #5852b5;
  text-transform: uppercase;
  font-size: 18px;
  margin: 20px 0;
  cursor: pointer;
  /* @media only screen and (min-width: 375px) {
    height: 56px;
    font-size: 20px;
  } */
  &&.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
`;
export const SeedInput = styled.input`
  font-family: "GT America, regular";
  background: transparent;
  border: solid 3px;
  border-radius: 38px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 18px;
  padding: 0 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.notify
      ? "color: #ff3920; border-color: #ff3920;"
      : "color: #ffb000; border-color: #ffb000;"}
  &::placeholder {
    color: #ffb000;
  }
  outline: none;
  /* @media only screen and (min-width: 375px) {
    height: 56px;
    font-size: 20px;
  } */
`;
export const Description = styled.div`
  font-size: 20px;
  margin-bottom: 30px;
  line-height: 1.33;
  h3 {
    text-transform: uppercase;
    margin-bottom: 13px;
  }
  h4 {
    font-size: 16px;
  }
  p {
    font-size: 16px;
    font-family: "GT America, regular";
  }
  /* @media only screen and (min-width: 375px) {
    font-size: 26px;
    h4 {
      font-size: 20px;
    }
    p {
      font-size: 20px;
    }
  } */
`;
export const DetailedContainer = styled.div`
  border-radius: 18px;
  border: solid 3px #233b50;
  /* width: 260px; */
  margin: auto;
  /* @media only screen and (min-width: 375px) {
    width: 315px;
  } */
`;
export const DetailedDescription = styled.div`
  padding: 14px 20px;
  h4 {
    font-size: 16px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  p {
    font-size: 10px;
  }
  /* @media only screen and (min-width: 375px) {
    h4 {
      font-size: 20px;
    }
    p {
      font-size: 12px;
    }
  } */
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  text-align: center;
  h4 {
    width: 50%;
    text-align: center;
    padding: 10px;
    border-top: solid 3px #233b50;
    border-bottom: solid 3px #233b50;
    text-transform: uppercase;
    :first-child {
      border-right: solid 3px #233b50;
    }
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  align-items: center;
  min-height: 188px;
  border-bottom: solid 3px #233b50;
  &&.centered {
    justify-content: center;
  }
  &&.border-b {
    border-bottom: none;
  }
  :first-child {
    border-right: solid 3px #233b50;
  }
`;
export const Box = styled.div`
  padding: 10px 0;
  border: solid 3px #ffb000;
  /* width: 100px;
  font-size: 10px; */
  margin: 10px auto;
  width: 120px;
  font-size: 12px;

  text-transform: uppercase;
  position: relative;
  &&.round {
    border-radius: 23px;
  }
  svg {
    transform: translateY(1px) translateX(3px);
  }
  /* @media only screen and (min-width: 375px) {
  } */
`;
export const Romb = styled.div`
  font-size: 10px;
  padding: 10px 0;
  position: relative;
  width: 70px;
  border-top: solid 3px #ffb000;
  border-bottom: solid 3px #ffb000;
  margin: 10px auto;
  text-transform: uppercase;
  :after {
    content: "";
    position: absolute;
    border: solid #ffb000;
    border-width: 0 3px 3px 0;
    display: inline-block;
    transform: rotate(315deg);
    top: 2.5px;
    height: 23.8px;
    width: 23.8px;
    right: -13.5px;
  }
  :before {
    content: "";
    position: absolute;
    border: solid #ffb000;
    border-width: 0 3px 3px 0;
    display: inline-block;
    transform: rotate(135deg);

    top: 2.5px;
    height: 23.8px;
    width: 23.8px;
    left: -13.5px;
  }
  font-size: 12px;
  width: 90px;
  /* @media only screen and (min-width: 375px) {
    :after {
      padding: 11.8px;
      right: -13.5px;
      top: 2.5px;
    }
    :before {
      padding: 11.95px;
      left: -13.65px;
      top: 2.45px;
    }*/
  } 
`;
export const Circle = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: absolute;
  background: #5852b5;
  border: solid 1px #ffb000;
  z-index: 2;
  right: -5px;
  bottom: 50%;
  transform: translateY(50%);
  box-shadow: 0px 0px 0px 2px #ffb000;
  &&.left {
    right: unset;
    left: -5px;
  }
  &&.top {
    bottom: unset;
    top: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &&.bottom {
    bottom: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &.rightCorner {
    bottom: -5px;
    right: -5px;
    transform: translateY(0);
  }
  &.leftCorner {
    bottom: unset;
    top: -5px;
    left: -5px;
    transform: translateY(0);
  }
`;
export const Line = styled.div`
  height: 3px;
  width: 40px;
  position: absolute;
  z-index: 1;
  background: #ffb000;
  right: -40px;
  bottom: 50%;
  transform: translateY(50%);
  &&.down {
    height: 35px;
    width: 3px;
    right: 50%;
    bottom: -35px;
    transform: translateY(0) translateX(50%);
  }
  &&.diagTop {
    width: 75px;
    right: -75px;
    bottom: 50%;
    transform: translateY(0) translateX(0) rotate(-61deg);
    transform-origin: left;
    width: 80px;
    right: -80px;
    transform: translateY(0) translateX(0) rotate(-57deg);
    /* @media only screen and (min-width: 375px) {
    } */
  }
  &&.diagBot {
    width: 75px;
    right: -75px;
    bottom: 50%;
    transform: translateY(0) translateX(0) rotate(61deg);
    transform-origin: left;
    width: 80px;
    right: -80px;
    transform: translateY(0) translateX(0) rotate(57deg);
    /* @media only screen and (min-width: 375px) {
    } */
  }
  &&.diagBotLong {
    width: 100px;
    right: -100px;
    transform: translateY(0) translateX(0) rotate(71deg);
    bottom: 0;
    transform-origin: left;
    transform: translateY(0) translateX(0) rotate(66deg);
    /* @media only screen and (min-width: 375px) {
    } */
  }
`;
